import { CertificateActions } from "../../CertificateDocs/CertificateActions";
import { DocumentCard } from "../../../../../../components/common/DocumentCard";
import { EhrResponsiveTable } from "../../../mobile/EhrResponsiveTable";

export function NoteReport({
  rowData = [],
  handleOpen,
  setBinaryUrl,
  sign,
  setRefetch,
}: any) {
  const columns = [
    { column: "Profissional", rowName: "practitioner" },
    { column: "Data", rowName: "date" },
    { column: "Especialidade", rowName: "specialty" },
  ];

  return (
    <EhrResponsiveTable
      title="Relatórios e atestados"
      hideSectionHeader
      columns={columns}
      rows={rowData}
      actions={(row: any) => (
        <CertificateActions
          setRefetch={setRefetch}
          row={row}
          handleOpen={handleOpen}
          setBinaryUrl={setBinaryUrl}
        />
      )}
      renderCard={(row) => (
        <DocumentCard
          key={row.id ?? row.date}
          title="Relatório médico"
          date={row.date}
          practitioner={row.practitioner}
          specialty={row.specialty}
          actions={
            <CertificateActions
              setRefetch={setRefetch}
              row={row}
              handleOpen={handleOpen}
              setBinaryUrl={setBinaryUrl}
            />
          }
        />
      )}
    />
  );
}
